export default __webpack_public_path__ + "static/07.logo_white-bg-eb802c1189ed0aaffb93f80e7f50b928.svg";